<template>
  <div>
    <div>
      <textarea class="full_width" v-model="innerText" placeholder="..."></textarea>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': isLoading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'next-contact-form',
  props: {
    text: {
      type: String
    },
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      innerText: this.text,
      isLoading: false
    }
  },
  methods: {
    ...mapActions('modals', ['removeModal']),
    async submit () {
      this.isLoading = true
      await this.onSubmit(this.innerText)
      this.isLoading = false
      this.removeModal(this.$attrs.payload.modal_id)
    }
  }
}
</script>
